(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.packsInitialized === 'true') return;
    root.dataset.packsInitialized = 'true';
    document.body.classList.add('template-collection-packs-cooldo');
    var cards = Array.from(root.querySelectorAll('[data-pack-card]'));
    var empty = root.querySelector('[data-packs-empty]');
    var inputs = [];
    var values = { size: [], flavor: [] };
    var enabled = { size: !!root.querySelector('[data-pack-options="size"]'), flavor: !!root.querySelector('[data-pack-options="flavor"]') };
    function key(value) { return value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-'); }
    function parse(value) { try { return JSON.parse(value || '[]').map(function (x) { return x.trim(); }).filter(Boolean); } catch (_) { return []; } }
    cards.forEach(function (card) {
      card.packValues = { size: parse(card.dataset.packSize), flavor: parse(card.dataset.packFlavors) };
      Object.keys(values).forEach(function (dimension) {
        card.packValues[dimension].forEach(function (label) { if (!values[dimension].some(function (x) { return x.key === key(label); })) values[dimension].push({ key: key(label), label: label }); });
      });
    });
    root.querySelectorAll('[data-pack-options]').forEach(function (fieldset, panelIndex) {
      var dimension = fieldset.dataset.packOptions;
      fieldset.hidden = values[dimension].length === 0;
      values[dimension].forEach(function (option) {
        var label = document.createElement('label');
        var input = document.createElement('input');
        input.type = 'radio'; input.name = 'pack-' + root.id + '-' + dimension + '-' + panelIndex;
        input.value = option.key; input.dataset.packFilter = dimension;
        var text = document.createElement('span'); text.textContent = option.label;
        label.append(input, text); fieldset.appendChild(label); inputs.push(input);
      });
    });
    var state = { size: '', flavor: '' };
    function read() {
      var url = new URL(window.location.href);
      Object.keys(state).forEach(function (dimension) {
        var requested = url.searchParams.get('pack_' + dimension) || '';
        var found = values[dimension].find(function (x) { return x.key === requested || (dimension === 'size' && x.key.replace(/-ml$/, '') === requested); });
        state[dimension] = enabled[dimension] && found ? found.key : '';
      });
    }
    function apply(updateUrl) {
      var count = 0;
      cards.forEach(function (card) {
        card.hidden = Object.keys(state).some(function (dimension) { return state[dimension] && !card.packValues[dimension].some(function (label) { return key(label) === state[dimension]; }); });
        if (!card.hidden) count++;
      });
      inputs.forEach(function (input) { input.checked = input.value === state[input.dataset.packFilter]; });
      root.querySelectorAll('[data-packs-clear]').forEach(function (button) { button.hidden = !state.size && !state.flavor; });
      if (empty) empty.hidden = count > 0;
      if (updateUrl) {
        var url = new URL(window.location.href);
        Object.keys(state).forEach(function (dimension) { if (state[dimension]) url.searchParams.set('pack_' + dimension, state[dimension]); else url.searchParams.delete('pack_' + dimension); });
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    }
    inputs.forEach(function (input) { input.addEventListener('change', function () { state[input.dataset.packFilter] = input.value; apply(true); }); });
    root.querySelectorAll('[data-packs-clear]').forEach(function (button) { button.addEventListener('click', function () { state.size = ''; state.flavor = ''; apply(true); }); });
    var toggle = root.querySelector('[data-packs-filter-toggle]');
    if (toggle) toggle.addEventListener('click', function () {
      var collapsed = toggle.closest('.iurop-packs-collection__catalog').classList.toggle('is-filter-collapsed');
      toggle.setAttribute('aria-expanded', String(!collapsed));
    });
    var mobile = root.querySelector('[data-packs-mobile-filters]');
    if (mobile) mobile.open = root.dataset.openMobile === 'true';
    function restore() { if (root.isConnected) { read(); apply(false); } }
    restore(); window.addEventListener('popstate', restore);
    root.packsCleanup = function () { window.removeEventListener('popstate', restore); };
  }
  function scan(scope) { if (scope.matches && scope.matches('[data-packs-collection]')) init(scope); scope.querySelectorAll('[data-packs-collection]').forEach(init); }
  scan(document);
  if (!window.cooldoEditablePackEvents) {
    window.cooldoEditablePackEvents = true;
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-packs-collection]').forEach(function (root) { if (root.packsCleanup) root.packsCleanup(); }); });
  }
}());
